export default __webpack_public_path__ + "static/media/kitten3S.e1fa2235.webp";